var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { fluid: "", "grid-list-md": "" } },
    [
      _c(
        "v-tabs",
        { attrs: { left: "", color: "transparent" } },
        [
          _c("v-tab", { on: { click: _vm.selectOperation } }, [
            _vm._v("Resumen Operacional")
          ]),
          _c("v-tab", { on: { click: _vm.selectTransmission } }, [
            _vm._v("Estado de transmisión")
          ]),
          _c("v-tab", { on: { click: _vm.selectKilometer } }, [
            _vm._v("Kilometraje")
          ])
        ],
        1
      ),
      _c("v-divider"),
      _vm.tabSelected == 0
        ? _c("DashboardOs", {
            attrs: { load: _vm.loadGraphOperation },
            on: { notifyLoad: _vm.notifyLoadOperation }
          })
        : _vm._e(),
      _vm.tabSelected == 1
        ? _c("DashboardTs", {
            attrs: {
              load: _vm.loadGraphTransmission,
              loadOperation: _vm.notifyLoadOp
            }
          })
        : _vm._e(),
      _vm.tabSelected == 2
        ? _c("DashboardKi", { attrs: { loadOperation: _vm.notifyLoadOp } })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }